import { styled } from 'goober';

export const Body = styled('form')`
    display: flex;
    flex-direction: column;

    button.rf-select__action {
        display: none !important;
    }
`;

export const Footer = styled('div')`
    display: flex;
    width: 100%;
    gap: 12px;
    justify-content: flex-end;
`;
